module.exports = __webpack_public_path__ + "static/img/BANK-E-AUCTION-LOGO-PNG-B.20f5a5a9.png";